"use client";

import React, { useEffect, useState, useRef } from "react";
import Autoplay from "embla-carousel-autoplay";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from "@/components/ui/carousel";
import { X } from "lucide-react";

function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}

const CHUNK_SIZE = 10; // Har chunk mein kitne quotes add karne hain

const DailyQuote = () => {
  const [allQuotes, setAllQuotes] = useState([]);
  const [visibleQuotes, setVisibleQuotes] = useState([]);
  const [addHeight, setAddHeight] = useState(false);
  const plugin = useRef(
    Autoplay({
      delay: 12000,
      stopOnInteraction: true,
    })
  );

  useEffect(() => {
    const fetchQuotes = async () => {
      try {
        const res = await fetch("/data/quotes.json");
        const data = await res.json();
        const shuffled = shuffleArray(data);
        setAllQuotes(shuffled);
        setVisibleQuotes(shuffled.slice(0, CHUNK_SIZE));
      } catch (error) {
        console.error("Failed to load quotes:", error);
      }
    };

    fetchQuotes();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setVisibleQuotes((prev) => {
        const nextIndex = prev.length;
        const nextChunk = allQuotes.slice(nextIndex, nextIndex + CHUNK_SIZE);
        if (nextChunk.length === 0) return prev; // All loaded
        return [...prev, ...nextChunk];
      });
    }, 12000); // Same as carousel autoplay delay

    return () => clearInterval(interval);
  }, [allQuotes]);

  if (visibleQuotes.length === 0) return null;

  return (
    <Carousel
      opts={{
        align: "start",
        loop: true,
      }}
      plugins={[plugin.current]}
      className="w-full max-w-xs mx-auto mt-16"
      onMouseEnter={plugin.current.stop}
      onMouseLeave={() => plugin.current.play()}
    >
      <div className="flex justify-between items-center gap-2 px-1">
        <div className="text-xs px-1.5 py-0.5 color_white bg_black w-fit">
          drag — left or right
        </div>
        <div className="color_black cursor-pointer transition-all hover:color_red border border-black">
          <X
            size={17}
            className={`${addHeight ? "rotate-45" : "rotate-0"}`}
            onClick={() => setAddHeight(!addHeight)}
          />
        </div>
      </div>
      <CarouselContent>
        {visibleQuotes.map((quote, index) => (
          <CarouselItem key={index} className="cursor-grabbing">
            <div
              className={`p-1 transition-all duration-500 ease-in-out ${
                addHeight ? "h-8 overflow-hidden mb-10" : "h-auto"
              }`}
            >
              <div className="border-2 border-dashed border-black p-4 max-w-xs mx-auto">
                <p className="italic color_white bg_red neue_machina_regular">
                  "{quote.quote}"
                </p>
                <p className="text-right mt-3 font-semibold uppercase color_black">
                  - {quote.author}
                </p>
              </div>
            </div>
            <div className="text-sm color_black text-right mt-2.5">
              powered by{" "}
              <a
                href="https://www.youtube.com/@micro_dive?sub_confirmation=1"
                className="color_red text-lg shadow_hand underline underline-offset-4 uppercase"
              >
                micro_dive
              </a>
            </div>
          </CarouselItem>
        ))}
      </CarouselContent>
    </Carousel>
  );
};

export default DailyQuote;
